import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { PaymentResult } from "../models/payment-result.model";





export class CustomersController {


    constructor(public _http: HttpClient) {
    }
    needDataUpdate(customerId: number): Promise<any> {



        return this._http.get(API_ADDRESS + `/general/needdataupdate/${customerId}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise();
    }

}
